import { useState } from "react";
import { Eye, EyeSlash, Image as ImageIcon, Microphone } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Pill } from "@/components/admin/AdminUI";
import { adminMediaUrl } from "@/lib/api";
import { formatDuration } from "@/lib/format";

// A reported chat photo / voice note. Nothing is requested until "Show" (every open is audited as report.media_view).
export default function ReportMessageMedia({ m }) {
  const [shown, setShown] = useState(false);
  const [failed, setFailed] = useState(false);
  const voice = m.kind === "voice";
  if (!m.has_media) return <p className="cw-muted mt-1 text-xs" data-testid={`report-media-legacy-${m.id}`}>Media not available for reports filed before this update.</p>;
  if (!m.media_url) return <p className="cw-muted mt-1 text-xs" data-testid={`report-media-gone-${m.id}`}>This file is no longer available.</p>;
  const src = adminMediaUrl(m.media_url);
  return (
    <div className="mt-1 space-y-2" data-testid={`report-media-${m.id}`}>
      {(m.nudity_flag || m.view_once) && (
        <div className="flex flex-wrap gap-1.5">
          {m.nudity_flag && <Pill tone="warning" data-testid={`report-media-nudity-${m.id}`}>Flagged: may contain nudity{m.nudity_score != null ? ` (score ${Number(m.nudity_score).toFixed(2)})` : ""}</Pill>}
          {m.view_once && <Pill data-testid={`report-media-view-once-${m.id}`}>View-once</Pill>}
        </div>
      )}
      {!shown ? (
        <div className="relative flex h-40 w-56 flex-col items-center justify-center gap-2 overflow-hidden rounded-xl bg-[var(--cw-surface-tertiary)]" data-testid={`report-media-blurred-${m.id}`}>
          <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(0,0,0,0.06),rgba(0,0,0,0.16))] blur-xl" aria-hidden />
          <span className="cw-soft relative flex items-center gap-1 text-xs">{voice ? <><Microphone size={14} />Voice note{m.duration_s != null ? ` · ${formatDuration(m.duration_s)}` : ""}</> : <><ImageIcon size={14} />Photo</>}</span>
          <Button size="sm" variant="outline" className="relative bg-white" onClick={() => setShown(true)} data-testid={`report-media-show-${m.id}`}><Eye size={14} />Show</Button>
        </div>
      ) : (
        <div className="space-y-1">
          {voice
            ? <audio controls src={src} onError={() => setFailed(true)} className="w-56" data-testid={`report-media-audio-${m.id}`} />
            : <img src={src} alt="Reported attachment" onError={() => setFailed(true)} className="max-h-64 rounded-xl" data-testid={`report-media-image-${m.id}`} />}
          {failed && <p className="cw-error text-xs" role="alert" data-testid={`report-media-error-${m.id}`}>Couldn’t open it. The link may have expired: reload the report.</p>}
          <Button size="sm" variant="ghost" onClick={() => { setShown(false); setFailed(false); }} data-testid={`report-media-hide-${m.id}`}><EyeSlash size={14} />Hide</Button>
        </div>
      )}
    </div>
  );
}
